import { create } from 'zustand';

export type Language = 'en' | 'ar' | 'id';

const STORAGE_KEY = 'nabat-language';

export interface LanguageState {
  language: Language;
  isRTL: boolean;
  setLanguage: (language: Language) => void;
}

// Helper to get initial language from localStorage or default to 'en'
function getInitialLanguage(): Language {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === 'en' || stored === 'ar' || stored === 'id') {
      return stored;
    }
  } catch (error) {
    console.warn('Failed to read language from localStorage:', error);
  }
  return 'en';
}

// Helper to check if a language uses RTL
function isRTLLanguage(language: Language): boolean {
  return language === 'ar';
}

export const useLanguageStore = create<LanguageState>((set) => {
  const initialLanguage = getInitialLanguage();

  return {
    language: initialLanguage,
    isRTL: isRTLLanguage(initialLanguage),

    setLanguage: (language: Language) => {
      // Persist to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, language);
      } catch (error) {
        console.warn('Failed to save language to localStorage:', error);
      }

      // Update state
      set({
        language,
        isRTL: isRTLLanguage(language),
      });
    },
  };
});
